import { HttpServerOption } from '@dooboostore/simple-boot-http-server/option/HttpServerOption';

export class HttpSSRServerOption extends HttpServerOption {
}
